import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import LatestVideos from './components/LatestVideos';
import NewsletterSection from './components/NewsletterSection';
import { siteInfo } from '@/mocks/articles';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        email: siteInfo.email,
        address: {
          '@type': 'PostalAddress',
          addressLocality: '上海',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          'target': `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: `${siteInfo.name} - 首页`,
        url: siteInfo.url,
        description: siteInfo.description,
        isPartOf: {
          '@type': 'WebSite',
          name: siteInfo.name,
          url: siteInfo.url,
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedVideos />
        <LatestVideos />
        <NewsletterSection />
      </main>

      <Footer />
    </>
  );
}